import React from 'react'

const SuccessGreenScg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 65.312 66.697'
    >
      <g
        id='check-svgrepo-com_3_'
        data-name='check-svgrepo-com (3)'
        transform='translate(-4.738 129.5)'
      >
        <g
          id='Group_318'
          data-name='Group 318'
          transform='translate(5.082 -129.5)'
        >
          <path
            id='Path_1552'
            data-name='Path 1552'
            d='M69.608,37.24l-1.254-1.717a4.115,4.115,0,0,1-.041-4.784l1.227-1.731a4.1,4.1,0,0,0-1.418-5.984l-1.867-1.009a4.111,4.111,0,0,1-2.113-4.294l.354-2.1a4.093,4.093,0,0,0-3.871-4.771l-2.126-.1A4.094,4.094,0,0,1,54.737,7.8l-.586-2.045A4.088,4.088,0,0,0,48.59,3.136l-1.949.845a4.09,4.09,0,0,1-4.675-1.036L40.548,1.364a4.1,4.1,0,0,0-6.147.041l-1.39,1.608a4.106,4.106,0,0,1-4.648,1.1l-1.963-.8a4.1,4.1,0,0,0-5.52,2.712l-.559,2.045A4.038,4.038,0,0,1,16.627,11.1l-2.126.123a4.085,4.085,0,0,0-3.789,4.825l.382,2.085a4.092,4.092,0,0,1-2.045,4.321L7.195,23.487a4.093,4.093,0,0,0-1.322,6L7.127,31.2a4.115,4.115,0,0,1,.041,4.784L5.941,37.717A4.1,4.1,0,0,0,7.358,43.7l1.867,1.009A4.111,4.111,0,0,1,11.338,49l-.368,2.085a4.093,4.093,0,0,0,3.871,4.771l2.126.1a4.094,4.094,0,0,1,3.762,2.958l.586,2.045a4.088,4.088,0,0,0,5.561,2.617l1.949-.845A4.107,4.107,0,0,1,33.5,63.751l1.418,1.581a4.1,4.1,0,0,0,6.147-.041l1.39-1.608a4.106,4.106,0,0,1,4.648-1.1l1.963.8a4.1,4.1,0,0,0,5.52-2.712l.559-2.045a4.122,4.122,0,0,1,3.721-3.012l2.126-.123a4.085,4.085,0,0,0,3.789-4.825L64.4,48.58a4.092,4.092,0,0,1,2.045-4.321L68.3,43.223A4.091,4.091,0,0,0,69.608,37.24ZM37.74,54.891A21.522,21.522,0,1,1,59.263,33.369,21.523,21.523,0,0,1,37.74,54.891Z'
            transform='translate(-5.426 0)'
            fill='#205c42'
          />
          <path
            id='Path_1553'
            data-name='Path 1553'
            d='M180.769,196.921,178.861,195a2.925,2.925,0,0,0-4.13-.014h0a2.925,2.925,0,0,0-.014,4.13l1.908,1.922,2.126,2.126a2.842,2.842,0,0,0,4.021.014l2.126-2.113,7.415-7.374a2.925,2.925,0,0,0,.014-4.13h0a2.925,2.925,0,0,0-4.13-.014Z'
            transform='translate(-150.864 -162.98)'
            fill='#205c42'
          />
        </g>
      </g>
    </svg>
  )
}

export default SuccessGreenScg
